import React from 'react';
import { Button } from '../ui/button';
import { Separator } from '../ui/separator';
import { Phone, Mail } from 'lucide-react';
import ShareButtons from '../ShareButtons';
import { EMPRESAS_ASOCIADAS, INSTAGRAM_URL, LOGO_URL, trackShare } from './constants';

export const LandingFooter = () => (
  <footer className="bg-slate-900 text-white py-16" data-testid="landing-footer">
    <div className="container mx-auto px-4">
      <div className="grid md:grid-cols-4 gap-8">
        <div>
          <div className="flex items-center space-x-3 mb-6">
            <img src={`${LOGO_URL}/:/rs=h:200,cg:true,m/qt=q:95`} alt="IwannaInsurance Logo" className="h-10 w-auto rounded-lg" />
            <div>
              <h4 className="text-xl font-bold">IwannaInsurance</h4>
              <p className="text-slate-400 text-sm">Seguros inteligentes</p>
            </div>
          </div>
          <p className="text-slate-400 leading-relaxed">
            Revolucionando la industria de seguros con tecnología avanzada y un enfoque centrado en el usuario.
          </p>
        </div>

        <div>
          <h5 className="text-lg font-bold mb-4 text-white">Contacto</h5>
          <div className="space-y-3">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center"><Phone className="h-4 w-4 text-white" /></div>
              <span className="text-slate-300" data-testid="footer-phone">+58 424 222 7314</span>
            </div>
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center"><Mail className="h-4 w-4 text-white" /></div>
              <span className="text-slate-300">info@iwannainsurance.com</span>
            </div>
          </div>
        </div>

        <div>
          <h5 className="text-lg font-semibold mb-4 text-white">Aliados</h5>
          <div className="space-y-2" data-testid="footer-partners">
            {EMPRESAS_ASOCIADAS.map((e) => <p key={e.nombre} className="text-slate-300 text-sm">{e.nombre}</p>)}
          </div>
        </div>

        <div>
          <h5 className="text-lg font-bold mb-4 text-white">Síguenos</h5>
          <Button
            data-testid="footer-instagram-btn"
            className="bg-gradient-to-r from-pink-500 to-purple-500 text-white rounded-full px-6 py-2 hover:shadow-lg transition-all duration-300"
            onClick={() => window.open(INSTAGRAM_URL, '_blank')}
          >
            Instagram
          </Button>
        </div>
      </div>

      <Separator className="my-12 bg-slate-700" />

      <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-slate-400">
        <div className="text-center md:text-left">
          <p>&copy; 2025 IwannaInsurance. Todos los derechos reservados.</p>
          <p className="mt-2 text-sm">Diseñado para la era digital</p>
        </div>
        <ShareButtons variant="dark" onShare={trackShare} />
      </div>
    </div>
  </footer>
);

export default LandingFooter;
